import React, { useState } from "react";
import "./MainPageEmailBox.scss";
import { toast } from "react-toastify";
import axios from "axios";
import {prefixUrl} from "../../Utils/utilsData";

const MainPageEmailBox = () => {

  const [email, setEmail] = useState("");
  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(email);
  };

  const submition = () => {
    if (email === "") {
      toast.error("ایمیل خود را وارد کنید");
      return;
    }

    if (!validateEmail(email)) {
      toast.error("ایمیل خود را به درستی وارد کنید");
      return;
    }

    const data = {
      email: email,
    };

    axios
      .post(`${prefixUrl()}/newsletter/add.php`, data)
      .then((response) => {
        if (response.data.status) {
          setEmail(""); // Clear the input
          setTimeout(() => {
            toast.success(response.data.message); // Display success toast after a delay
          }, 0);
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Error submitting email");
      });
  };

  return (
    <div className="emailBoxWrapper__">
      <div className="emailBoxContent__">
        <h6>برای اطلاع از آخرین اخبار و محصولات در خبرنامه ما عضو شوید</h6>
        <div className="emailGroupInput__">
          <input
            type="email"
            placeholder="ایمیل شما ..."
            onChange={emailChangeHandler}
            required={true}
            value={email}
          />
          <button className="sendBtn__" onClick={submition}>
            ارسال
          </button>
        </div>
      </div>
    </div>
  );
};

export default MainPageEmailBox;
